import api from "./api";
import { createQueryParams } from "../Helpers/QueryParams";

export const getTrackerChart = async (params: any): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const queryParams = createQueryParams(params);
        const response = await api.get(`/tracker/graph-data?${queryParams.toString()}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Chart Data");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};

export const getTrackerTable = async (params: any): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const queryParams = createQueryParams(params);
        const response = await api.get(`/tracker/table-data?${queryParams.toString()}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Chart Data");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};

export const getAvailableYears = async (clientId: string): Promise<number[]> => {
    try {
        const token: string | null = localStorage.getItem("token");

        const response = await api.get(`/tracker/available-years/${clientId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (response.data.status) {
            return response.data.data; // Should be an array of years (number[])
        } else {
            throw new Error(response.data.message);
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get available years");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};

export const getDataIntegrityReport = async (params: any): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token");
        const queryParams = createQueryParams(params);
        const response = await api.get(`/tracker/data-integrity-report?${queryParams.toString()}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message);
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Data Integrity Report");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};